import React, { Component } from "react";
import { Field, reduxForm, change } from "redux-form";

import { render_field } from "../../../../utils/renderField";
import HandShake from './../../../../img/handshake.png'

class ConfirmEmail extends Component {
  onSubmit() {
    this.props.next();
  }

  componentDidMount() {
    this.props.dispatch(change("emailForm", "email", this.props.email));
  }

  componentDidUpdate(prevProps) {
    //prevProps.email !== this.props.email ? this.props.dispatch(change('emailForm', 'email', this.props.email)) : null
    if (prevProps.email !== this.props.email) {
      this.props.dispatch(change("emailForm", "email", this.props.email));
    }
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="row">
        <div className="col-md-6">
          <h1 className="account__logo-accent">Hi there,</h1>
          <br />
          <h3 className="account__subhead">
            We are so happy to partner with you on your journey to better
            security and compliance. Let's get you set up in 3 easy steps.
          </h3>
          <form
            className="form"
            id="confirm-email"
            onSubmit={handleSubmit(this.onSubmit.bind(this))}
          >
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  id="email"
                  name="email"
                  component={render_field}
                  type="email"
                  placeholder="Email Address"
                  // onChange={this.props.handleChange}
                  defaultValue={this.props.email}
                  onChange={(evt) => evt.preventDefault()}
                />
              </div>
              <button className="onBoardingBtn" style={{ cursor: "pointer", width: "150px" }}>
                Let's Get Started!
              </button>
            </div>
          </form>
        </div>
        <div className="col-md-1"></div>
        <div className="col-md-5">
          <div style={{marginTop: "25px"}}></div>
          <img src={ HandShake }/>
        </div>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  const re =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

  if (!values.email) {
    errors.email = "Enter your email address";
  }

  if (!re.test(values.email)) {
    errors.email = "Enter a correct email address";
  }

  return errors;
}

export default reduxForm({
  form: "emailForm",
  validate,
})(ConfirmEmail);



// WEBPACK FOOTER //
// ./src/pages/account/register/components/ConfirmEmail.js